export type CopyNode =
  | string
  | { readonly type: "trademark" }
  | { readonly type: "break" }
  | { readonly type: "link"; readonly href: string; readonly text: string; readonly external: boolean };

export type Copy = readonly CopyNode[];

export const TRADEMARK: CopyNode = { type: "trademark" };

export const BREAK: CopyNode = { type: "break" };

export const link = (text: string, href: string, external = false): CopyNode => ({
  type: "link",
  href,
  text,
  external,
});

export const LOOP_TM: Copy = ["LOOP", TRADEMARK];
